import { createActionCreators, createActionTypes } from "../../utils/reduxUtils"

const typesActions = [
    'FETCH_MASAV_EXPORTS_REQUEST',
    'FETCH_MASAV_EXPORTS_SUCCESS',
    'FETCH_MASAV_EXPORTS_FAILURE',

    'FETCH_SINGLE_MASAV_EXPORT_REQUEST',
    'FETCH_SINGLE_MASAV_EXPORT_SUCCESS',
    'FETCH_SINGLE_MASAV_EXPORT_FAILURE',

    'UPLOAD_CONFIRMATION_REQUEST',
    'UPLOAD_CONFIRMATION_SUCCESS',
    'UPLOAD_CONFIRMATION_FAILURE',
]

export const Actions = createActionCreators(typesActions);
export const ActionsTypes = createActionTypes(typesActions);

